import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Chip } from "@components/ui/Chip"
import { VenueTileFragment } from "@generated-types"
import { Link } from "eddev/routing"

type Props = {
  venue: VenueTileFragment
}

export function VenueTile(props: Props) {
  const address = JSON.parse(props.venue.info?.address || "{}") as any

  return (
    <Link href={props.venue.uri} className="group flex flex-col">
      <div className="overflow-hidden aspect-[4/3] bg-bg-low relative">
        <ResponsiveImage {...props.venue.venueHeader?.image} max />
        <div className="absolute left-2 bottom-2 flex flex-wrap gap-2">
          <Chip variant="high" shape="rounded">
            {props.venue.info?.venueCategory}
          </Chip>
        </div>
      </div>
      <div className="py-4 flex flex-col gap-1">
        <div className="type-label-m">{props.venue.title}</div>
        {address.Street && <div className="type-body-s text-fg-secondary">{address.Street}</div>}
      </div>
    </Link>
  )
}
